/**
 * @mitt 事件总线
 * @param { function } on 接受
 * @param { function } emit 触发(渲染后钩子使用)
 * @param { function } off 清除(销毁钩子使用)
 */
import mitt from 'mitt'

export default new mitt();